import { MATIC_PRODUCT_ID, MATIC_SELLING_PLAN_GROUP_NAME, MATIC_REFKIT_VARIANT_ID } from "../consts/shopify";

export const formatPrice = (amount, currency = "USD") => {
  const price = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(amount);

  return price;
};

export const isInStock = (quantity, availableForSale) => {
  if (quantity === null) return availableForSale;

  return availableForSale && quantity > 0;
};

export const isMainMatic = (node) => {
  return node.merchandise.product.id === MATIC_PRODUCT_ID;
};

export const isRefKit = (node) => {
  return node.merchandise.id === MATIC_REFKIT_VARIANT_ID;
};

export const getMaticDepositPrice = (mainProduct) => {
  const maticSellingPlanGroup = mainProduct.product.sellingPlanGroups.edges.find(edge => edge.node.name === MATIC_SELLING_PLAN_GROUP_NAME);
  return maticSellingPlanGroup.node.sellingPlans.edges[0].node.checkoutCharge.value.amount;
}

export const sanitizeHtml = html => {
  const allowedTags = {
    a: true,
    p: true,
    b: true,
    strong: true,
    em: true,
    br: true,
    ul: true,
    li: true,
  };

  return html.replace(/<\/?([^>]+)>/g, (match, tag) => {
    const cleanTag = tag.toLowerCase().trim();
    return allowedTags[cleanTag] ? match : "";
  });
};
